export const STATUS = {
    won: 'GANHO',
    lost: 'PERDIDO',
    open: 'ABERTO',
}
